// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import "jspdf-autotable";
// import { API_BASE_URL } from "../../../Config/Config";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import UpdatedUserGroupTable from "./UpdatedUserGroupsTable";
// import EndPoints from "../../../Api/EndPoints";

// const UpdatedUserGroupsDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
//   const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clintBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;;

//   const fetchDashboardData = async () => {
//     try {
//       const response = await fetch(
//         `${EndPoints.GetAllUserGroups}?client_branch_id=${clintBranchId}&user_name=${UserName}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           "Failed to fetch dashboard data. Please check the API or authentication details."
//         );
//       }

//       const result = await response.json();
      
//       const tableData = result?.data || []; 
//       const rawHeaders = tableData[0] || [];
//       const rows = tableData.slice(1) || [];

//       const formattedHeaders = rawHeaders.map((header) =>
//         String(header).replace(/^[a-zA-Z]\*/, "")
//       );
//       const transformedRows = rows.map((row) =>
//         row.map((cell) => {
//           if (cell === "" || cell === null || cell === undefined) {
//             return "---";
//           }
//           return cell;
//         })
//       );

//       setHeaders(formattedHeaders);
//       setReportDashboardData(transformedRows);


//       // const result = await response.json();
//       // const rawHeaders = result?.headers || [];
//       // const rows = result?.table_data || [];
//       // const formattedHeaders = rawHeaders.map((header) =>
//       //   String(header).replace(/^[a-zA-Z]\*/, "")
//       // );
//       // const transformedRows = rows.map((row) =>
//       //   row.map((cell) => (cell === "" || cell === null || cell === undefined ? "---" : cell))
//       // );

//       // setHeaders(formattedHeaders);
//       // setReportDashboardData(transformedRows);

//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "37px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="">
//         <div
//           style={{
//             backgroundColor: "white",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             zIndex: 1001,
//             top: 0,
//           }}
//         >
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             User Group Dashboard
//           </p>
//             <div style={{ display: "flex" }}>
//             {/* <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//               onClick={handleCancel} 
//             >
//               CANCEL
//             </button> */}
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 width: "180px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               disabled={selectedRows.length === 0}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={() => { navigate(`/manage_group_employee`); }}
//             >
//               MANAGE EMPLOYEE 
//             </button>
//              <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 width: "190px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               disabled={selectedRows.length === 0}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={() => { navigate(`/user_group_role_access`); }}
//             >
//               MANAGE ROLE ACCESS
//             </button>
//             <button className="create-test-section-btn" onClick={() => { navigate(`/updated_create_user_group`); }} >
//               NEW
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "10px", color: "#2F2E40" }}>
//           Created role requests are listed here click on a group name to check status, edit or cancel the request or create a new request using New button.
//         </p>
//         <div>
//           <UpdatedUserGroupTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Question Papers..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             renderQuestionText={renderQuestionText}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={false}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdatedUserGroupsDashboard;

























// UpdatedUserGroupsDashboard.jsx
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import UpdatedUserGroupTable from "./UpdatedUserGroupsTable";
// import EndPoints from "../../../Api/EndPoints";
// import he from "he";

// const UpdatedUserGroupsDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath, // keep for compatibility if parent uses it
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);

//   // This will hold the function exposed by the table to navigate to role access
//   const [goToRoleAccess, setGoToRoleAccess] = useState(null);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [dataClient]);

//   const renderQuestionText = (questionText) => {
//     if (!questionText) return "";
//     const decodedQuestion = he.decode(String(questionText));
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             {segment}
//           </span>
//         );
//       }
//     });
//   };

//   const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
//   const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clintBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;

//   const fetchDashboardData = async () => {
//     try {
//       const response = await fetch(
//         `${EndPoints.GetAllUserGroups}?client_branch_id=${clintBranchId}&user_name=${UserName}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch dashboard data.");
//       }

//       const result = await response.json();
//       const tableData = result?.data || [];
//       const rawHeaders = tableData[0] || [];
//       const rows = tableData.slice(1) || [];

//       // strip n*/t*/d* prefixes to make headers readable and consistent
//       const cleanedHeaders = rawHeaders.map((h) =>
//         String(h).replace(/^[a-z]\*/, "").trim()
//       );

//       const transformedRows = rows.map((row) =>
//         row.map((cell) => (cell === "" || cell === null || cell === undefined ? "---" : cell))
//       );

//       setHeaders(cleanedHeaders);
//       setReportDashboardData(transformedRows);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   return (
//     <div style={{ height: "auto", width: "100%", paddingLeft: "37px", marginBottom: "40px" }}>
//       <div>
//         <div style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 1001, top: 0 }}>
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>User Group Dashboard</p>
//           <div style={{ display: "flex" }}>
//             {/* MANAGE EMPLOYEE (restored) */}
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 width: "180px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               disabled={selectedRows.length === 0}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={() => {
//                 navigate(`/manage_group_employee`);
//               }}
//             >
//               MANAGE EMPLOYEE
//             </button>

//             {/* MANAGE ROLE ACCESS — primary working button kept */}
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 width: "190px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               disabled={selectedRows.length === 0}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={() => {
//                 // prefer the helper exposed by the table; fallback to navigate with minimal data
//                 if (typeof goToRoleAccess === "function") {
//                   goToRoleAccess();
//                 } else {
//                   const idIndex = headers.findIndex((h) => /User Group ID/i.test(String(h)));
//                   const selectedRowsData = reportDashboardData.filter((r) => {
//                     const idVal = idIndex !== -1 ? r[idIndex] : r[0];
//                     return selectedRows.includes(idVal);
//                   });
//                   navigate("/user_group_role_access", { state: { selectedRowsData, headers } });
//                 }
//               }}
//             >
//               MANAGE ROLE ACCESS
//             </button>

//             <button className="create-test-section-btn" onClick={() => navigate(`/updated_create_user_group`)}>
//               NEW
//             </button>
//           </div>
//         </div>

//         <p style={{ marginTop: "10px", color: "#2F2E40" }}>
//           Created role requests are listed here — click on a group name to check status, edit or cancel the request or create a new request using New button.
//         </p>

//         <div>
//           <UpdatedUserGroupTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Question Papers..."
//             dataClient={dataClient}
//             setPagePath={setGoToRoleAccess} // receive helper from table here
//             renderQuestionText={renderQuestionText}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={false}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdatedUserGroupsDashboard;

















import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UpdatedUserGroupTable from "./UpdatedUserGroupsTable";
import Endpoints from "../../../Api/Endpoints";
import he from "he";

const UserGroupsDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath, 
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  // This will hold the object exposed by the table (expected keys: toRoleAccess, toManageEmployee)
  const [tableNavigators, setTableNavigators] = useState(null);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    if (!questionText) return "";
    const decodedQuestion = he.decode(String(questionText));
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            {segment}
          </span>
        );
      }
    });
  };

  const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
  const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clintBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;

  const fetchDashboardData = async () => {
    try {
      const response = await fetch(
        `${Endpoints.PRISM_GET_ALL_USER_GROUPS}?client_branch_id=${clintBranchId}&user_name=${UserName}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch dashboard data.");
      }

      const result = await response.json();
      const tableData = result?.data || [];
      const rawHeaders = tableData[0] || [];
      const rows = tableData.slice(1) || [];

      // strip n*/t*/d* prefixes to make headers readable and consistent
      const cleanedHeaders = rawHeaders.map((h) =>
        String(h).replace(/^[a-z]\*/, "").trim()
      );

      const transformedRows = rows.map((row) =>
        row.map((cell) => (cell === "" || cell === null || cell === undefined ? "---" : cell))
      );

      setHeaders(cleanedHeaders);
      setReportDashboardData(transformedRows);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const handleCancel = () => {
    window.location.reload();
  };

  // Helper to build selectedRowsData from current dashboard state (fallback)
  const buildSelectedRowsData = () => {
    const idIndex = headers.findIndex((h) => /User Group ID/i.test(String(h)));
    const sel = Array.isArray(selectedRows) ? selectedRows : [];
    const selectedRowsData = reportDashboardData.filter((r) => {
      const idVal = idIndex !== -1 ? r[idIndex] : r[0];
      return sel.includes(idVal);
    });
    return selectedRowsData;
  };

  // MANAGE EMPLOYEE: prefer tableNavigators.toManageEmployee(), fallback to navigate with constructed state
  const handleManageEmployee = () => {
    if (tableNavigators && typeof tableNavigators.toManageEmployee === "function") {
      tableNavigators.toManageEmployee();
      return;
    }

    // fallback: build minimal selectedRowsData from selectedRows and navigate
    const selectedRowsData = buildSelectedRowsData();
    if (selectedRowsData.length === 0) {
      // nothing selected — do nothing (button should be disabled) but keep fallback safe
      return;
    }
    navigate("/manage_group_employee", { state: { rowData: selectedRowsData[0], headers } });
  };

  // MANAGE ROLE ACCESS: prefer tableNavigators.toRoleAccess(), fallback to navigate with constructed state
  const handleManageRoleAccess = () => {
    if (tableNavigators && typeof tableNavigators.toRoleAccess === "function") {
      tableNavigators.toRoleAccess();
      return;
    }

    const selectedRowsData = buildSelectedRowsData();
    if (selectedRowsData.length === 0) return;
    navigate("/user_group_role_access", { state: { selectedRowsData, headers } });
  };

  return (
    // <div style={{ height: "auto", width: "100%", paddingLeft: "37px", marginBottom: "40px", overflowX: "hidden" }}>
    // <div style={{ height: "auto", width: "100%", paddingLeft: "37px", overflowX: "hidden" }}>
    <div style={{ height: "100%", width: "100%", paddingLeft: "37px", overflowX: "hidden" }}>
      <div>
        <div style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 1001, top: 0 }}>
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>User Group Dashboard</p>
          <div style={{ display: "flex" }}>
            {/* MANAGE EMPLOYEE (restored) */}
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                width: "180px",
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              disabled={selectedRows.length === 0}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
              onClick={handleManageEmployee}
            >
              MANAGE MEMBER
            </button>

            {/* MANAGE ROLE ACCESS — primary working button kept */}
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                width: "190px",
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              disabled={selectedRows.length === 0}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
              onClick={handleManageRoleAccess}
            >
              MANAGE ROLE ACCESS
            </button>

            <button className="create-test-section-btn" onClick={() => navigate(`/updated_create_user_group`)}>
              NEW
              <span style={{fontSize: "14px", fontWeight: "bold", padding: "0px 0px 1px 0px"}}>+</span>
            </button>
          </div>
        </div>

        <p style={{ marginTop: "10px", color: "#2F2E40" }}>
          Created User Groups are listed here — click on a group name to check status or edit, click on New to create new group, click on Manage Employee to add employees or on Manage Role Access to add roles to the group.
        </p>

        <div>
          <UpdatedUserGroupTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter User Groups..."
            dataClient={dataClient}
            setPagePath={setTableNavigators} // receive helper object from table here
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
          />
        </div>
      </div>
    </div>
  );
};

export default UserGroupsDashboard;


